const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/905065376985"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
      aria-label="WhatsApp ile iletişime geç"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
    </a>
  );
};

export default WhatsAppButton;
